// extracted by mini-css-extract-plugin
module.exports = {"baggagePrice__price":"baggagePrice__price-3i1QU","baggagePrice__control":"baggagePrice__control-26Cox","baggagePrice__priceEdit":"baggagePrice__priceEdit-2F0CK"};